/**
 * Factory: gridState
 */
angular.module('acme.common.factory.gridState', [])
.factory('GridStateFactory', [ function() {


  function GridState() {

    return {

      constructor: GridState,

      gridState: {
        page: 1,
        pageSize: 50,
        sortField: 'createdOn',
        sortDirection: 'desc',
        search: '',
        totalItems: 0
      },

      init: function() {
        this.gridState = {
          page: 1,
          pageSize: 50,
          sortField: 'createdOn',
          sortDirection: 'desc',
          search: '',
          totalItems: 0
        };
      },

      /**
       *
       * Builds datasource object
       *  - First fn builds any required gridState config.
       *  - Second is the Api call.
       *  - Third is success function.
       *    successFn requires both response
       * and params args.
       * @param custom {function}
       * @param api call {function}
       * @param success callback {function}
       * @returns {*}
       */
      buildDataSource: function (customFn, apiCall, successFn) {
        var r = null;

        if (typeof (customFn && apiCall && successFn) === "function") {
          r = {
            rowCount: -1,
            pageSize: this.getPropertyValue('pageSize'),
            getRows: function (params) {
              var props = customFn(params);
              apiCall(props).then(function (response) {
                successFn(response, params);
              });
            }
          };
        }
        return r;
      },

      getGridState: function () {
        return this.gridState;
      },

      setGridState: function (gridState) {
        this.gridState = gridState;
      },

      getPropertyValue: function (property) {
        return this.gridState[property];
      },

      setPropertyValue: function (property, value) {
        this.gridState[property] = value;
      },

      updateGridState: function (page, pageSize, sortField, sortDirection, search, totalItems) {
        if (page) {
          this.setPropertyValue('page', page);
        }

        if (pageSize) {
          this.setPropertyValue('pageSize', pageSize);
        }

        if (sortField) {
          this.setPropertyValue('sortField', sortField);
        }

        if (sortDirection) {
          this.setPropertyValue('sortDirection', sortDirection);
        }

        if (search) {
          this.setPropertyValue('search', search);
        }

        if (totalItems) {
          this.setPropertyValue('totalItems', totalItems);
        }
      },

      resetGridState: function () {
        this.gridState = {
          page: 1,
          pageSize: 50,
          sortField: 'createdOn',
          sortDirection: 'desc',
          search: '',
          totalItems: 0
        };
      },

      applyPreferences: function(config) {
        if (config) {
          this.processSortPreferences(config.sortField, config.sortDirection, config.columns);
          this.processPaginationPreferences(config.pageSize, config.pageSizes);
        }
      },

      processPaginationPreferences: function(pageSize, pageSizes) {
        if(pageSize && !isNaN(parseInt(pageSize, 10)) && (pageSizes.indexOf(pageSize) > -1)) {
          this.gridState.pageSize = pageSize;
        }
      },

      processSortPreferences: function(sortField, sortDirection, columns) {
        if (sortField && columns instanceof Array) {
          if (columns.indexOf(sortField)) {
            this.gridState.sortField = sortField;
            this.gridState.sortDirection = this.getSortDirection(sortDirection);
          }
        }
      },

      getSortDirection: function(sortDirection) {
        var r = 'asc';
        if (sortDirection && sortDirection === 'desc') {
          r = sortDirection;
        }

        return r;
      }

    };
  }

  return GridState;

}]);
